import { render } from "./BackPageBtn.vue?vue&type=template&id=9bc47f0e&scoped=true"
import script from "./BackPageBtn.vue?vue&type=script&lang=js"
export * from "./BackPageBtn.vue?vue&type=script&lang=js"

import "./BackPageBtn.vue?vue&type=style&index=0&id=9bc47f0e&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc47f0e"]])

export default __exports__